<div class="header-bar">
  <h1>Job Notification Settings</h1>
</div>

<div class="content-container" [hidden]="editMode">
  <div class="ui-g" style="border-radius: 10px; border: 1.5px solid #c7c7c7">
    <div style="background-color: #f1f1f1; border-radius: 9px 9px 0 0; width: 100%">
      <div class="ui-g-6 p-3">
        <span class="section-header"
          >Job Alerts
          <span
            class="info-i"
            tooltipStyleClass="xtooltip text-left"
            pTooltip="Customise the types of new jobs you want to be alerted about by creating, disabling or enabling alerts."
            >i</span
          >
        </span>
      </div>
      <div class="ui-g-6 py-2 px-3">
        <div style="text-align: right">
          <button
            pButton
            icon="fa fa-plus"
            label="Create Alert"
            (click)="newAlertSetting('')"
          ></button>
        </div>
      </div>
    </div>

    <div style="background-color: #fff; border-radius: 0 0 9px 9px; overflow: hidden">
      <div class="job-alert-settings">
        <p-table
          [hidden]="!settingsLoaded"
          [style]="{ width: '100%' }"
          rowHover="true"
          resizableColumns="true"
          [rowsPerPageOptions]="[10, 20, 30]"
          [scrollable]="true"
          [responsive]="true"
          [pageLinks]="3"
          tableStyleClass="job-alert-settings-table table-no-top-corners"
          [totalRecords]="alertSettingList?.length"
          [value]="alertSettingList"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 50px"></th>
              <th style="width: 180px">Alert</th>
              <th style="">Description</th>
              <th style="width: 100px"></th>
              <th style="width: 100px">Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td style="width: 50px; text-align: center; font-size: 18px">
                <i class="fa fa-bell-o"></i>
              </td>

              <td style="width: 180px; font-weight: bold">
                <div *ngIf="item.id" (click)="item.canEdit ? editAlertSetting(item.id) : false">
                  {{ item.settingName }}
                </div>
                <div
                  *ngIf="!item.id"
                  (click)="item.canEdit ? newAlertSetting('Custom Setting') : false"
                >
                  {{ item.settingName }}
                </div>
              </td>

              <td>
                <div *ngIf="item.id > 0" (click)="item.canEdit ? editAlertSetting(item.id) : false">
                  <span *ngIf="item.followOnMovements">Follow-on Job</span>
                  <span *ngIf="item.returnJourneyMovements">Return Journey to home</span>

                  <span *ngIf="item.canEdit">
                    <span *ngIf="item.dateFrom != null"
                      >Between {{ item.dateFrom | datex : 'DD/MM/YY' }} -{{
                        item.dateTo | datex : 'DD/MM/YY'
                      }}
                      |
                    </span>

                    <span *ngIf="item.pickupLocationPostcode?.length > 0"
                      >Pickup {{ item.pickupLocationPostcode }} ({{ item.distanceToPickup }} miles)
                      |
                    </span>

                    <span *ngIf="item.dropoffLocationPostcode?.length > 0"
                      >Dropoff {{ item.dropoffLocationPostcode }} ({{ item.distanceToDropoff }}
                      miles) |
                    </span>

                    <span *ngIf="item.noticePeriod > 0"
                      >{{ item.noticePeriodHours }}hrs notice |</span
                    >

                    {{ item.timeFrom / 100 }}:00-{{ item.timeTo / 100 }}:00 | Max
                    {{ item.distanceToPickup }} miles from Pickup | Max
                    {{ item.distanceToDropoff }} miles from Dropoff
                  </span>
                </div>

                <div *ngIf="item.id == null" (click)="newAlertSetting('Custom Setting')">
                  Click to view/update settings
                </div>
              </td>
              <td style="width: 100px; font-size: 18px">
                <span *ngIf="item.canEdit">
                  <i
                    class="las la-pencil-alt link-style mr-4"
                    (click)="editAlertSetting(item.id)"
                  ></i>
                  <i class="fa fa-trash-o link-style" (click)="deleteSelected(item.id)"></i>
                </span>
              </td>
              <td style="width: 100px">
                <p-inputSwitch
                  [disabled]="item.id == null || disabledSwitch(item)"
                  [(ngModel)]="item.enabled"
                  (onChange)="enableChanged($event, item)"
                ></p-inputSwitch>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showDisableEmail"
  [closable]="false"
  [modal]="true"
  [style]="{ width: '450px' }"
>
  <p-header>
    <strong>Disable email notifications?</strong>
  </p-header>

  <div>
    Disable this notification may result in drivers being unaware of crucial job details and cause
    potential disruption to operations.
  </div>

  <div>Are you sure you want to proceed?</div>

  <div class="mt-3 text-right">
    <button
      pButton
      label="Yes, Disable"
      class="ui-button ui-button-danger mr-2"
      (click)="changeReminderSetting(itemChosen)"
    ></button>
    <button
      pButton
      label="No, Cancel"
      class="ui-button ui-button-grey"
      (click)="itemChosen.enabled = true; showDisableEmail = false"
    ></button>
  </div>
</p-dialog>

<p-dialog
  [modal]="true"
  [style]="{ width: '450px' }"
  [closable]="false"
  [(visible)]="showDisableSMS"
>
  <p-header>
    <strong>Disable SMS notifications?</strong>
  </p-header>

  <div>
    Disable this notification may result in drivers being unaware of crucial job details and cause
    potential disruption to operations.
  </div>

  <div>Are you sure you want to proceed?</div>

  <div class="mt-3 text-right">
    <button
      pButton
      label="Yes, Disable"
      class="ui-button ui-button-danger mr-2"
      (click)="changeReminderSetting(itemChosen)"
    ></button>
    <button
      pButton
      label="No, Cancel"
      class="ui-button ui-button-grey"
      (click)="itemChosen.enabled = true; showDisableSMS = false"
    ></button>
  </div>
</p-dialog>

<div class="p-3 mt-3" [hidden]="editMode">
  <div class="ui-g" style="border-radius: 10px; border: 1.5px solid #c7c7c7">
    <div style="background-color: #f1f1f1; border-radius: 9px 9px 0 0; width: 100%">
      <div class="ui-g-6 p-3">
        <span class="section-header"
          >Job Notifications
          <span
            class="info-i"
            tooltipStyleClass="xtooltip text-left"
            pTooltip="Select how you would like to be reminded about your upcoming jobs"
            >i</span
          >
        </span>
      </div>
    </div>

    <div style="background-color: #fff; border-radius: 0 0 9px 9px; overflow: hidden">
      <div class="job-alert-settings">
        <p-table
          [hidden]="!settingsLoaded"
          [style]="{ width: '100%' }"
          rowHover="true"
          resizableColumns="true"
          [rowsPerPageOptions]="[10, 20, 30]"
          [scrollable]="true"
          [responsive]="true"
          [pageLinks]="3"
          tableStyleClass="job-alert-settings-table table-no-top-corners"
          [value]="reminderSettings"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 50px"></th>
              <th style="width: 180px">Notification Type</th>
              <th style="">Description</th>
              <th style="width: 100px">Status</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td style="width: 50px; text-align: center; font-size: 18px">
                <i class="fa {{ item.icon }}"></i>
              </td>
              <td style="width: 180px">
                <strong>{{ item.type }}</strong>
              </td>
              <td style="">
                {{ item.description }}
              </td>
              <td style="width: 100px">
                <p-inputSwitch
                  [disabled]="disabledReminderSwitch(item)"
                  [(ngModel)]="item.enabled"
                  (onChange)="enableReminderChanged($event, item)"
                ></p-inputSwitch>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<job-alert-settings-edit
  [canDelete]="true"
  [editMode]="editMode"
  (editModeChange)="editModeChange($event)"
></job-alert-settings-edit>
